import { put, takeLatest, select } from "redux-saga/effects"
import * as timeslotsChannelActions from "app/redux/personalPlanningChannel/personalPlanningChannel.actions"
import { SagaIterator } from "redux-saga"
import { formatDateToWeek } from "utils/formatDateToWeek"
import * as weekActions from "../weeks/weeks.actions"
import * as actions from "./personalPlanning.actions"
import { notifyIfServerError } from "../utils"
import { getUserId } from "../authorization/authorization.selectors"

export function* getTimeslots(action: actions.GetTimeslotsAction): SagaIterator {
  try {
    const {
      params: { from, to },
    } = action.payload
    const week = formatDateToWeek(from)
    const uid = yield select(getUserId)
    yield put(timeslotsChannelActions.disconnectTimeslotsChannel())
    yield put(weekActions.getWeeks(week))
    yield put(timeslotsChannelActions.connectTimeslotsChannel({ week, uid, from, to }))
  } catch (e) {
    yield put(actions.getPersonalPlanningTimeslotsFail(e))
    yield put(notifyIfServerError({ error: e }))
  }
}
export default function* personalPlanningSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getTimeslots)
}
